// "Zuletzt geöffnete Vorgänge": reine Bequemlichkeit pro Browser (localStorage) - es wird nichts am Server gespeichert und nichts verändert.
// Gemerkt werden nur Art, ID und eine kurze Beschriftung (Belegnummer bzw. Datum/Betrag); keine Kontodaten.
const SCHLUESSEL = "finanz_zuletzt_v1";
const MAX = 8;

export const zuletztGeoeffnet = {
  lesen() {
    try { const l = JSON.parse(localStorage.getItem(SCHLUESSEL)); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  },
  merken(eintrag) {
    try {
      const rest = this.lesen().filter(v => !(v.typ === eintrag.typ && v.id === eintrag.id));
      localStorage.setItem(SCHLUESSEL, JSON.stringify([{ ...eintrag, zeit: Date.now() }, ...rest].slice(0, MAX)));
    } catch (e) { /* Speicher nicht verfuegbar - ignorieren */ }
  },
};
